import { createFileRoute } from '@tanstack/react-router';

import { useSEO, useBreadcrumbSchema, PageSEO } from '../lib/seo';
import { LegalDocPage } from '../components/legal/LegalDocPage';
import { DocWarning } from '../components/legal/DocWarning';
// Body (TOC + clauses + doc-footer) extracted verbatim from the 2026-04-28
// static page sites/www/public/privacy/index.html. Rendered as-is to avoid
// transcription risk on legal text; the relocated bits (title, meta, subtitle,
// version warning) are structured JSX above.
import privacyBody from '../content/legal/privacy.body.html?raw';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});

function PrivacyPage() {
  useSEO(PageSEO.privacy);
  useBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Trust', url: '/trust' },
    { name: 'Privacy Notice', url: '/privacy' },
  ]);

  return (
    <LegalDocPage
      title="Privacy Notice"
      breadcrumbLabel="Privacy Notice"
      metaLine="v3.0 · 28 April 2026"
      subtitle="How Neumind collects, uses, and protects personal data across our website, app, and professional dashboard."
      warning={
        <DocWarning summary="Version 3.0 — under regulatory review">
          <p>
            <strong>Version 3.0 (2026-04-28) — This version supersedes the November 2025 baseline.</strong>{' '}
            It is currently under regulatory review by Orion MedTech as part of the CSO HIPS/25/14
            engagement; we may issue revisions following their sight. Material changes will be
            published with a version log entry and notified inside the product where applicable.
          </p>
        </DocWarning>
      }
    >
      <div dangerouslySetInnerHTML={{ __html: privacyBody }} />
    </LegalDocPage>
  );
}
